import { DefaultLoader, LoaderContainer } from 'components/Loader';
import { FC, useContext } from 'react';
import { MentorshipManagementContext } from '..';
import Mentor from './Mentor';
import NoMentorship from './NoMentorship';
import RefusedMentee from './RefusedMentee';

const MentorshipPage: FC = () => {
  const { mentorship, error } = useContext(MentorshipManagementContext);
  if (error) {
    return <NoMentorship />;
  }
  if (!mentorship) {
    return (
      <LoaderContainer>
        <DefaultLoader />
      </LoaderContainer>
    );
  }
  switch (mentorship.status) {
    case 'MENTOR_ACCEPTING':
    case 'REFUSED_MENTOR':
    case 'INTERRUPTED_ADMIN':
      return <NoMentorship />;
    case 'REFUSED_MENTEE':
      return <RefusedMentee />;
    default:
      return <Mentor />;
  }
};

export default MentorshipPage;
